import { tokens } from '@vp/swan';

const PROGRESS_COLOR = tokens.SwanSemColorBgPromoStrongPaired;
const BACKGROUND_COLOR = tokens.SwanSemColorBgStrongActive;

export interface Props {
    value: number;
    min: number;
    max: number;
    strokeWidth: number;
    size: number;
}

export function CircularProgressBar({ value, min, max, strokeWidth, size }: Props) {
    const clampedValue = Math.min(Math.max(value, min), max);

    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (clampedValue / max) * circumference;

    const transitionStyle = {
        transition: 'stroke-dashoffset 0.5s ease-in-out, stroke 0.5s ease-in-out',
    };

    return (
        <svg width={size} height={size} transform="rotate(-90)" viewBox={`0 0 ${size} ${size}`}>
            <circle
                fill="none"
                cx={size / 2}
                cy={size / 2}
                r={radius}
                stroke={BACKGROUND_COLOR}
                strokeWidth={strokeWidth}
                shapeRendering="optimizeQuality"
                data-testid="progress-bg-circle"
            />
            <circle
                fill="none"
                cx={size / 2}
                cy={size / 2}
                color={PROGRESS_COLOR}
                r={radius}
                strokeLinecap="round"
                stroke={tokens.SwanSemColorBorderInfoStrongPaired}
                strokeWidth={strokeWidth}
                strokeDasharray={circumference}
                strokeDashoffset={offset}
                shapeRendering="optimizeQuality"
                data-testid="progress-circle"
                style={transitionStyle}
            />
        </svg>
    );
}
